export default {
  back: "Back to all subexponents",
  access: "Access",
  deleteSubexp: "Delete subexponent"
};
